import axios from "axios";

const B_URL = process.env.REACT_APP_LOGINURL

const getContactUsMessages = (sessionID, page, limit, type, status, search) => {
    var payload = {
        "functionName": "GetContactUs",
        "postData": {
            "offset": page,
            "sort": {
                "_id": -1
            },
            "limit": limit,
            "type": type,
            "status": status,
            "search": search
        }
    }
    const headers = {
        'Content-Type': 'application/json',
        'token': sessionID
    }
    return axios.post(B_URL + "ContactUsModule/GetContactUs", payload, { headers });
};

const updateContactUsStatus = (sessionID, id, status) => {
    const payload = {
        functionName: "UpdateContactUsStatus",
        postData: {
            id,
            status,
        },
    };
    const headers = {
        "Content-Type": "application/json",
        token: sessionID,
    };
    return axios.post(B_URL + "ContactUsModule/UpdateContactUsStatus", payload, { headers });
};

const ContactUsService = {
    getContactUsMessages,
    updateContactUsStatus,
};

export default ContactUsService;
